Kubrick.Filterbar = {
  start: function() {
    Kubrick._log("Filterbar: Configuring...");
    let $BUTTONS = document.querySelectorAll(".filterbar .roundal");
    for (let i = 0; i < $BUTTONS.length; i++) {
      $BUTTONS[i].addEventListener("click", function() {
        Kubrick.Layout.saveCurrentScrollPosition();
      });
    }
  }
};
